import React from "react"
import { DropdownChangeParams, DropdownFilterParams } from "primereact/dropdown"
import { StyledDropdown } from "./styled"
import { FormInput } from "../formInput"
import { FlexContainer } from "../containers"
import { LoadingComponent } from "../loading"

interface Props {
  panelClassName?: string
  heading?: string
  label?: string
  transparent?: boolean
  value?: any
  name?: string
  options?: any[]
  onChange?: (e: DropdownChangeParams) => void
  placeholder?: string
  width?: string
  canSearch?: boolean
  border?: string
  required?: boolean
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void
  componenttype?: number
  showClear?: boolean
  id?: string
  disabled?: boolean
  hidden?: boolean
  onFilter?: (e: DropdownFilterParams) => void
  noResetFilterOnHide?: boolean
  onHide?: () => void
  onShow?: () => void
  filterPlaceholder?: string
  showLoadingTemplate?: boolean
  emptyMessage?: string
  emptyFilterMessage?: string
  filterFunction?: (item: any, options: any) => boolean
  resetFilterOnHide?: boolean
  filterValue?: string
  onFilterValueChange?: (e: { originalEvent: Event; value: string }) => void
  resetFilterOnClear?: boolean
  overlayVisible?: boolean
}

const Dropdown: React.FC<Props> = ({ ...props }) => {
  const loadingTemplate = () => (
    <FlexContainer style={{ cursor: "wait" }} justify="center">
      <LoadingComponent height="24px" />
    </FlexContainer>
  )
  return (
    <FormInput
      heading={props.heading}
      width={props.width}
      border={props.border}
      required={props.required}
    >
      <StyledDropdown
        panelClassName={props.panelClassName}
        $transparent={props.transparent}
        width={props.width}
        value={props.value}
        name={props.name}
        options={props.options}
        onChange={props.onChange}
        onFilter={props.onFilter}
        placeholder={props.placeholder}
        optionLabel="title"
        optionValue="value"
        filter={!!props.canSearch}
        showClear={!!(props.showClear || props.canSearch)}
        dropdownIcon="pi pi-chevron-down"
        onBlur={props.onBlur}
        id={props.id ?? props.name}
        disabled={props.disabled}
        resetFilterOnHide={!props.noResetFilterOnHide}
        onHide={props.onHide}
        onShow={props.onShow}
        data-testid={props.name}
        filterPlaceholder={props.filterPlaceholder}
        emptyMessage={props.emptyMessage}
        emptyFilterMessage={props.emptyFilterMessage}
        filterInputAutoFocus
        filterFunction={props.filterFunction}
        noResetFilterOnHide={props.noResetFilterOnHide}
        filterValue={props.filterValue}
        onFilterValueChange={props.onFilterValueChange}
        resetFilterOnClear={props.resetFilterOnClear}
        overlayVisible={props.overlayVisible}
      />
    </FormInput>
  )
}

export default Dropdown
